import React from 'react';
import { Button } from '../Common';

export const JumpToContent = () => {
  return (
    <div className="link-jump-to-content">
      <a href="#reach-skip-nav" data-reach-skip-link="" data-reach-skip-nav-link="" aria-describedby="app_page_title">
        Jump to Content
      </a>
    </div>
  );
};

export const JumpToContentAnchor = () => {
  return <div id="reach-skip-nav" data-reach-skip-nav-content></div>;
};

export const FocusToSearchResultNav = ({ contentRef, focusElId = null }) => {
  const handler = () => {
    contentRef.current?.scrollIntoView();
    focusElId ? setTimeout(() => document.getElementById(focusElId).focus(), 500) : void 0;
  };

  return (
    <Button
      isNew
      tabIndex="0"
      classNames={['link-jump-to-search']}
      onClick={handler}
      onKeyDown={(e) => (e.key === 'Enter' ? handler() : void 0)}
      appearance="secondary"
      shrank
      size="small"
      id="button-skip-to-content"
      data-testid="button-skip-to-content"
      text="Jump to search results"
    />
  );
};

export const FocusToSearchResultContent = ({ contentRef }) => {
  return <div id={'goto-content'} ref={contentRef} tabIndex={-1} aria-hidden="true"></div>;
};
